export const Welcome = {
  "title": "Welcome to the Foxit PDF Editor",
  "PhantomPdfContent": "This new version of the product has better performance and supports the same features as the old version, and more. If you already have a user account for PhantomPDF Online, please feel free to use your same account to enjoy the new features and performance.",
  "SignIn": "Sign In",
  "OnlineContent": "The Foxit Online tools have been combined into this product. Please continue to use these tools and all the other features of Foxit PDF Editor."
}